import { breakpoints } from '#app/theme/theme.js';
import { type WindowDimensionsData } from '../types.js';
import { createContext } from 'react';

export const createWindowDimensionsContext = ({
  height,
  width,
}: {
  height: number;
  width: number;
}) => {
  const isMobile = width < Number.parseInt(breakpoints.lg, 10);
  const isBelowSmallBreakpoint = width < Number.parseInt(breakpoints.sm, 10);
  const isBelowMediumBreakpoint = width < Number.parseInt(breakpoints.md, 10);
  const isBelowLargeBreakpoint = width < Number.parseInt(breakpoints.lg, 10);
  const isBelowExtraLargeBreakpoint =
    width < Number.parseInt(breakpoints.xl, 10);

  return {
    height,
    isBelowExtraLargeBreakpoint,
    isBelowLargeBreakpoint,
    isBelowMediumBreakpoint,
    isBelowSmallBreakpoint,
    isMobile,
    width,
  };
};

export const WindowDimensionsContext = createContext<WindowDimensionsData>(
  createWindowDimensionsContext({
    height: typeof window === 'undefined' ? 0 : window.innerHeight,
    width: typeof window === 'undefined' ? 0 : window.innerWidth,
  }),
);
